import React from 'react';
import { motion } from 'framer-motion';
import { FaShieldAlt, FaClock, FaHeart, FaMapMarkerAlt } from 'react-icons/fa';

const WhyChooseUs = () => {
  const reasons = [
    {
      icon: <FaShieldAlt size={40} />,
      title: "Safety First",
      description: "We maintain the highest standards of safety and security for all our clients. Our professional drivers are trained, certified, and committed to your well-being."
    },
    {
      icon: <FaClock size={40} />,
      title: "Reliable & Punctual",
      description: "Committed to punctual and dependable service for every journey. We understand that being on time is crucial for medical appointments and we take that responsibility seriously."
    },
    {
      icon: <FaHeart size={40} />,
      title: "Compassionate Care",
      description: "Treating each client with dignity, respect, and genuine care. We believe in providing transportation services that go beyond just getting you from point A to point B."
    },
    {
      icon: <FaMapMarkerAlt size={40} />,
      title: "Comprehensive Coverage",
      description: "Serving all 39 counties across Washington State since 2016. From Aberdeen to Spokane, from Bellingham to Vancouver, we're here to serve your transportation needs throughout the entire state."
    }
  ];

  return (
    <section className="why-choose-us" id="why-choose-us">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          viewport={{ once: true }}
        >
          <h2>Why Choose Sky Harbor Shuttle?</h2>
          <p>Locally owned and operated in Aberdeen, Washington, we've been providing quality transportation services to the people of Washington State since 2016.</p>
        </motion.div>
        
        <div className="reasons-grid">
          {reasons.map((reason, index) => (
            <motion.div
              className="reason-card"
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              viewport={{ once: true }}
              whileHover={{ 
                scale: 1.03, 
                boxShadow: "0 10px 20px rgba(0,0,0,0.1)" 
              }}
            >
              <motion.div 
                className="reason-icon"
                whileHover={{ scale: 1.1, rotate: 5 }}
              >
                {reason.icon}
              </motion.div>
              <h3>{reason.title}</h3>
              <p>{reason.description}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default WhyChooseUs;

